import type { AxiosError } from 'axios';
import useSWR from 'swr';
import type { GetStatusRequest, GetStatusResponse } from '~/api/aspida/@types';
import { getStatus } from '~/api/status';
import { statusAdapter } from '~/features/status/statusAdapter';

export const getStatusKey = (params: GetStatusRequest | null) =>
  params
    ? (['getStatus', params.child_id, params.date, params.regionCode, params.is_newbie] as const)
    : null;

export const useGetStatus = (params: GetStatusRequest | null) => {
  const {
    data,
    error,
    isLoading,
    mutate: revalidate,
  } = useSWR<GetStatusResponse, AxiosError>(getStatusKey(params), () => getStatus(params!), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const latestStatus = data ? statusAdapter(data.latest_status) : undefined;
  const nextStatus = data ? statusAdapter(data.next_measurement_status) : undefined;
  const recommendStatus = data ? statusAdapter(data.recommended_replacement_status) : undefined;

  return { data, latestStatus, nextStatus, recommendStatus, error, isLoading, revalidate };
};
